import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Resources from "../components/Resources";

const ResourcesPage = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState("resources");
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <Header
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />

      {/* Main Content */}
      <main className="pt-16">
        {/* Resources Section */}
        <Resources />
      </main>

      {/* Footer */}
      <Footer
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
    </div>
  );
};

export default ResourcesPage;
